<template>
  <div>
    <div class="father">
          <div>
            <h1>Main heading</h1>
            <h2>Sub heading</h2>
          </div>
          <div>
            <article>
              <img src="../../../static/img/多领域服务1.jpg" />
              <h2></h2>
              <div class="content_div">
                <h3>安防护卫</h3>
                <div class="litter_line"></div>
                <p>
                  宁波宏邦保安公司面向政府机关、金融机构、企事业单位、独资合资企业等其他场所提供门卫安全、责任区域安全巡逻、防盗、防火检查、其他应客户要求的安全防范。为各类大型活动；公共交通行业提供现场安检安保服务。维持现场秩序安全等。拥有最全面的安全检查设备和最专业安保精英团队，在法律规定范围内忠实地为您提供安全保卫服务，依法捍卫您的人身财产安全。
                </p>
                
              </div>
            </article>
            <article>
              <h2></h2>
              <img src="../../../static/img/多领域服务2.jpg" />
              <div class="content_div">
                <h3>安检设备租售</h3>
                <div class="litter_line"></div>
                <p>
                  为满足客户大型会议、体育赛事运动会、演唱会、会展等活动的临时需要宏邦保安提供以下防爆安检设备租赁业务，X光射线行李箱设备、便携式X光机、手持金属探测器、金属探测安检门、车底安全检查扫描系统等防爆安检设备，设备全部通过欧盟CE认证和ISO9001质量管理体系认证，符合ISO14001环境管理体系要求。
                </p>
              </div>
            </article>
            <article>
              <h2></h2>
              <img src="../../../static/img/多领域服务3.jpg" />
              <div class="content_div">
                <h3>保安培训</h3>
                <div class="litter_line"></div>
                <p>
                  宏邦从事多年保安培训工作，具有丰富的教学培训及管理经验，能够胜任岗前专业及各级层职业等级培训的需要，宏邦拥有专业的培训机构并与不同区域不同方位的多家培训学校达成合作协议接受培训学校的统一指导和监督，就近为各保安服务提供培训业务支持。
                </p>
              </div>
            </article>
            <article>
              <h2></h2>
              <img src="../../../static/img/多领域服务4.jpg" />
              <div class="content_div">
                <h3>物业服务</h3>
                <div class="litter_line"></div>
                <p>
                  宏邦拥有完善的物业后勤保障人员可为客户量身定制相应的物业后勤服务，根据客户要求，结合项目实际情况，按照客户属性定制整体解决方案物业项目整体运营管理，机电设备设施的安装保养与维修、物业保洁等，以“诚实守信，客户至上，以人为本，致精致诚”为核心，提供全程无忧服务。
                </p>
              </div>
            </article>
          </div>
        </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.father {
  width: 100%;
  height: 50rem;
  margin: 5rem auto;

.litter_line {
  display: inline-block;
  margin: 5rem 5rem 3rem 5rem;
  background-color: white;
  height: 1px;
  width: 20% !important;
}

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  * {
    transition: all 0.3s ease 0s;
  }

  .content_div {
    height: 100%;
    width: 100%;
    background: var(--textBlue60);
    position: absolute;
    top: 0;

    h3 {
      margin: 5rem 0 0 5rem;
      font-size: 3.5rem;
      font-family: bold;
    }

    p {
      margin: 0 5rem 0 5rem;
      width: auto;
      font-size: 1.8rem;
      font-family:light;
      line-height: 3rem;
    }

    .first_p {
      margin: 5rem 5rem 0 5rem;
    }
  }

  /* Background colours */
  div + div article:nth-child(1) {
    // background: #00c22326;
    // background-image: url('../../static/img/切片-38.jpg');
    background-repeat: no-repeat;
  }

  div + div article:nth-child(2) {
    // background: #f37338;
    // background-image: url('../../static/img/切片-39.jpg');
  }

  div + div article:nth-child(3) {
    // background: #fdb632;
    // background-image: url('../../static/img/切片-40.jpg');
  }

  div + div article:nth-child(4) {
    // background: #027878;
    // background-image: url('../../static/img/切片-41.jpg');
  }

  div + div article:nth-child(5) {
    // background: #801638;
    // background-image: url('../../static/img/切片-42.jpg');
  }

  div + div article:nth-child(6), div + div {
    // background: #800000;
    // background-image: url('../../static/img/切片-43.jpg');
    // height:100%;
    // background-repeat: no-repeat;
  }

  /* Main layout */
  html, body, div + div {
    width: 100%;
    height: 100%;
  }

  div + div {
    list-style: none;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    overflow: hidden;
  }

  /* Articles */
  div + div article {
    flex: initial;
    width: 25%;
    height: 100%;
    text-align: center;
    color: #fff;
    text-decoration: none;
    vertical-align: bottom;
    box-sizing: border-box;
    // padding: 2vh 1vw;
    position: relative;
  }

  /* Big Headings */
  div:first-child {
    display: none;
    position: fixed;
    bottom: 8vh;
    background: #fff;
    width: 100%;
    text-align: center;
    padding: 0.5rem;
    z-index: 2;
  }

  div:first-child h1, div:first-child h2 {
    margin: 0;
    padding: 0;
  }

  /* Hover interaction */
  div + div:hover article {
    flex: initial;
    width: 20%;
  }

  div + div article:hover {
    width: 50%;
  }

  article > div {
    opacity: 0;
    transition: opacity 0.2s ease 0;
  }

  div + div article:hover > div {
    opacity: 1;
    transition: opacity 0.3s ease 0.3s;
  }

  /* navigation */
  div + div article > h2 {
    bottom: 2vh;
    position: absolute;
    text-align: center;
    width: 100%;
    margin: 0;
    font-size: 3vh;
  }

  /* Article layouts */
  article div {
    text-align: left;
    width: 58vw;
  }

  article div p, article div div h2, article div h3 {
    margin: 0 0 1em 0;
  }

  h1, h2, h3, h4, h5, h6 {
    text-transform: uppercase;
  }

  article div p {
    width: 40vw;
  }


  @media (max-width: 900px) {
    div + div article {
      padding: 2vh 3vw;
    }

    div + div article > h2 {
      transform: rotate(90deg);
      bottom: 23vh;
      min-width: 12em;
      text-align: left;
      transform: rotate(-90deg);
      transform-origin: 0 0 0;
      opacity: 1;
    }

    div + div article:hover > h2 {
      opacity: 0;
    }

    article div p {
      width: 50vw;
    }

    article div {
      max-height: calc(72%);
      overflow-y: auto;
    }
  }
}
</style>